import React from "react";

function toneFor(value) {
  const key = String(value || "")
    .trim()
    .toLowerCase();
  if (!key || key === "—") return "";
  if (key === "online" || key.startsWith("online ")) return "biz-status-online";
  if (key === "offline" || key.startsWith("offline ") || key === "disabled") {
    return "biz-status-offline";
  }
  if (
    key === "active" ||
    key.startsWith("active ") ||
    key === "approved" ||
    key === "published" ||
    key === "enabled" ||
    key === "connected" ||
    key === "green" ||
    key === "high" ||
    key === "good"
  ) {
    return "biz-status-active";
  }
  return "";
}

export default function StatusCapsule({ value, children }) {
  const text = children != null && children !== "" ? children : value ?? "—";
  const extra = toneFor(text);
  return (
    <span className={`biz-status-pill${extra ? ` ${extra}` : ""}`}>{text}</span>
  );
}
